// Service for Managed Attendance (Marcas Gestionadas)
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';
import type {
  LC_GetManagedAttendanceIn,
  LC_GetManagedAttendanceMarksOut,
  LC_UpdateManagedMarkStatusIn,
  LC_UpdateManagedMarkStatusOut,
  ManagedAttendancePage,
} from '../types';
import { mapManagedAttendancePage } from '../mappers';


export class ManagedAttendanceService {
  async getManagedAttendance(
    employeeId: number,
    input: LC_GetManagedAttendanceIn,
  ): Promise<ApiResponse<ManagedAttendancePage>> {
    const queryString = buildQueryString({ ...input });
    const endpoint = `${API_CONFIG.ENDPOINTS.ATTENDANCE.GET_MANAGED_MARKS(employeeId)}${queryString}`;
    const response =
      await apiClient.get<LC_GetManagedAttendanceMarksOut>(endpoint);

    if (!response.success || !response.data) {
      return {
        success: false,
        data: null,
        error: response.error,
        status: response.status,
      };
    }

    return {
      success: true,
      data: mapManagedAttendancePage(response.data),
      status: response.status,
    };
  }

  async updateManagedMarkStatus(
    employeeId: number,
    markId: string,
    input: LC_UpdateManagedMarkStatusIn,
  ): Promise<ApiResponse<LC_UpdateManagedMarkStatusOut>> {
    const endpoint = API_CONFIG.ENDPOINTS.ATTENDANCE.UPDATE_MANAGED_MARK(employeeId, markId);
    return apiClient.patch<LC_UpdateManagedMarkStatusOut>(endpoint, input);
  }
}

export const managedAttendanceService = new ManagedAttendanceService();
